/**
 * Provides Text Input components.
 */
import * as React from 'react';

import { Platform, View } from 'react-native';
import styled from 'styled-components/native';

import { Colors } from 'theme/colors';
import { FontFamily, FontSize, FontWeight } from 'theme/fonts';
import { BORDER_RADIUS } from 'theme/sizes';
import { InlineError } from 'theme/errors';

export const INPUT_PADDING = Platform.select({
  android: 10,
  ios: 0,
});

const InputBase = styled.TextInput`
  border-color: ${Colors.steel};
  border-bottom-left-radius: ${BORDER_RADIUS};
  border-bottom-right-radius: ${BORDER_RADIUS};
  border-width: 1;
  font-family: ${Platform.OS === 'web' ? 'Roboto' : FontFamily.Light};
  font-weight: ${FontWeight.Light};
  font-size: ${FontSize.Regular};
  height: 50;
  margin-bottom: 7;
  margin-top: 0;
  margin-horizontal: 40;
  padding-top: ${INPUT_PADDING};
  text-align: center;
  color: ${Colors.black};
`;

export const Input = (props: App.Theme.InputProps) => {
  const { error, innerRef, onClearError, ...otherProps } = props;
  const borderRadius = {
    borderTopLeftRadius: error && error.length > 0 ? 0 : BORDER_RADIUS,
    borderTopRightRadius: error && error.length > 0 ? 0 : BORDER_RADIUS,
  };

  return (
    <View>
      {error ? <InlineError error={error} onClearError={onClearError} /> : null}
      <InputBase
        {...otherProps}
        style={[otherProps.style, borderRadius]}
        allowFontScaling={true}
        clearButtonMode={otherProps.clearButtonMode || 'while-editing'}
        underlineColorAndroid={Colors.transparent}
        placeholderTextColor={Colors.darkGrey}
        ref={innerRef}
      />
    </View>
  );
};
